import {
  NumberValue,
  ResponseNumberDecimalPoint,
} from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { convertDecimal } from 'src/exShared/util/numberDecimalPoint/numberDecimalPoint'
import { CellInner, TableBodyCellWrapper } from './Common.dumb'

type Props = {
  value?: NumberValue
  scale?: string
  decimalPoint?: ResponseNumberDecimalPoint
}

export const TableBodyCellNumber: FC<Props> = ({
  value,
  scale,
  decimalPoint,
}) => {
  const isInvalid = value?.isInvalid === 1
  const numberValue = value?.numberValue
  const cellValue =
    numberValue !== undefined ? convertDecimal(numberValue, decimalPoint) : ''

  return (
    <TableBodyCellWrapper
      backgroundColor={isInvalid ? 'invalid' : 'default'}
      fontColor={isInvalid ? 'invalid' : 'default'}
    >
      <CellInner>
        {cellValue}
        {scale}
      </CellInner>
    </TableBodyCellWrapper>
  )
}
